export const LIST_PAGE_LOAD_MORE_THRESHOLD_ROWS = 20;

export type ListPageTableSort<SortColumn extends string> = {
  colId: SortColumn;
  sort: 'asc' | 'desc';
} | null;

export const shouldLoadMoreListPageRows = ({
  lastDisplayedRowIndex,
  loadMoreRowIndex,
  hasMore,
  isFetchingMore,
}: {
  lastDisplayedRowIndex: number;
  loadMoreRowIndex: number | null;
  hasMore: boolean;
  isFetchingMore: boolean;
}): boolean =>
  hasMore &&
  !isFetchingMore &&
  loadMoreRowIndex !== null &&
  lastDisplayedRowIndex >=
    loadMoreRowIndex - LIST_PAGE_LOAD_MORE_THRESHOLD_ROWS;
